import React, { useState, useEffect } from "react";

export const useMousePos = (el) => {
  el = el || document;
  const [mousePos, setMousePos] = useState({});
  useEffect(() => {
    const getMousePos = e => {
      const posX = e.clientX;
      const posY = e.clientY;
      setMousePos({ posX, posY });
    };
    el.addEventListener("mousemove", getMousePos);
    return function cleanup() {
      el.removeEventListener("mousemove", getMousePos);
    };
  });
  return mousePos;
};
